module.exports = __webpack_public_path__ + "img/huoban2.beac014c.png";